import React, { Fragment } from 'react';
import { styled } from 'linaria/react';
import { useTheme } from '@shared/lib/theme';
import { Dot } from '@shared/ui/atoms';
import { breadcrumbsSizes } from '@shared/config/components/breadcrumbs';
import BreadcrumbItem, { BreadcrumbItemType } from './BreadcrumbItem';
type SizeValue = keyof typeof breadcrumbsSizes;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
export interface BreadcrumbsProps {
  size?: ResponsiveSize;
  items: BreadcrumbItemType[];
}
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  size = 's',
  items
}) => {
  const {
    theme
  } = useTheme();
  const desktopSize = typeof size === 'object' ? size.desktop || 's' : size || 's';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 's';
  return <BreadcrumbsWrapper>
      <BreadcrumbsItemsWrapper>
        {items?.map((item, index) => <Fragment key={item.label}>
            <BreadcrumbItem key={item.label} item={item} size={{
          desktop: desktopSize,
          mobile: mobileSize
        }} />
            {index !== items.length - 1 && <Dot color={theme.colors.constant.white} />}
          </Fragment>)}
      </BreadcrumbsItemsWrapper>
    </BreadcrumbsWrapper>;
};
export default Breadcrumbs;
const BreadcrumbsWrapper = /*#__PURE__*/styled('nav')({
  name: "BreadcrumbsWrapper",
  class: "b4k129e",
  propsAsIs: false
});
const BreadcrumbsItemsWrapper = /*#__PURE__*/styled('ol')({
  name: "BreadcrumbsItemsWrapper",
  class: "b2bttks",
  propsAsIs: false
});

require("./Breadcrumbs.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Breadcrumbs.tsx");